import {mapActions} from "vuex"

export default {
  methods: mapActions("message", [
    "setMessage",
    "clearMessage",
  ]),
}
